import { render, staticRenderFns } from "./benefits-center.vue?vue&type=template&id=6f962735&scoped=true"
import script from "./benefits-center.vue?vue&type=script&lang=js"
export * from "./benefits-center.vue?vue&type=script&lang=js"
import style0 from "./benefits-center.vue?vue&type=style&index=0&id=6f962735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f962735",
  null
  
)

export default component.exports